const tableHeaderCell = {
    background: '#FAFAFA',
    color: '#333333',
    fontWeight: 400,
    border: 0,
}

const tableCellstyle={
    borderright: 0,
    borderleft: 0,
}


//使用 import {tableHeaderCell,tableCellstyle} from "@/assets/js/config/publickStyle.js"

export default {
    tableHeaderCell,
    tableCellstyle
}